const MuiDialogTitle = {
    styleOverrides: {
        root: {
            padding: '1.5rem 1.5rem 1rem 1.5rem'
        },
    }
};

export default MuiDialogTitle;